import React from 'react';

export default class Footer extends React.Component {

  render() {
    let _footer_class = {
        "kron": "header-footer",
        "pd" : "header-footer",
        "wus": "header-footer wus-footer-bar",
        "pidanvpn": "header-footer pidan-footer",
    }
    let _footer = {
      "kron": <p style={{ color: "white", margin: "0" }}>
        © 2023 Q Technical Group Co., Ltd All rights reserved
      </p>,
      "pd": <p><p style={{ color: "white", margin: "0", backgroundColor: "rgb(1, 14, 85)"}}>
        © 2023 Q Tech Co., Ltd All rights reserved 皮蛋科技（成都）有限公司
      </p ><a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">蜀ICP备2021030742号</a></p>,
      "wus": <p style={{ color: "black", margin: "0" }}>
        © 2023 Q Tech Co., Ltd All rights reserved
      </p>,
      "pidanvpn": <p><p> © 2025 Pidan Communication (Chengdu) Co., Ltd. All rights reserved </p ><a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">蜀ICP备2025162000号</a></p>,
    }

    return (
      <footer className={_footer_class[process.env.PROJECT]}>
        {_footer[process.env.PROJECT]}
      </footer >
    );
  }
}
